<template>
    <Breadcrumbs :list="breadcrumpsList"/>
    <div class="main-card mb-3 card">
        <div class="card-body">
            <div v-if="importing">
                <h5 class="font-bold">Trwa import danych ({{bar.current}} z {{bar.count}})</h5>
                <pv-progress-bar  :value="bar.percent" class="mb-2"/>
            </div>

            <pv-toolbar v-if="enableAction" class="mb-4">

                <template #start>
                    <pv-button label="Dodaj" icon="pi pi-plus" class="p-button-primary me-2" @click="create()"  />
                </template>

                <template #end>

                </template>
            </pv-toolbar>
            <pv-table
                    ref="dt"
                    :value="dictionares"
                    :lazy="false"
                    :totalRecords="totalRecords"
                    :paginator="true"
                    :rows="20"
                    paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                    :rowsPerPageOptions="[20,50, 100]"
                    currentPageReportTemplate="{first} - {last} z {totalRecords}"
                    responsiveLayout="scroll"
                    :loading="loading"



            >

                <pv-column field="name" header="Nazwa" style="width: 300px">
                </pv-column>

                <pv-column field="description" header="Opis" style="width: auto">
                </pv-column>

                <pv-column field="active" header="Aktywny" dataType="boolean" style="width: 100px">
                    <template #body="{data}">
                        <i class="pi" :class="{'true-icon pi-check-circle': data.active, 'false-icon pi-times-circle': !data.active}"></i>
                    </template>
                </pv-column>
                <pv-column  style="width: 120px">
                    <template #body="{data}">
                        <pv-button icon="pi pi-list" class="p-button-rounded p-button-success" @click="values(data)" />
                    </template>
                </pv-column>
            </pv-table>

        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';

    import Breadcrumbs from '@miro-labs/vue3-architect-layout/layout/base/Breadcrumbs.vue'
    import ProgressBar from 'primevue/progressbar';
    import Toolbar from 'primevue/toolbar'
    import Button from 'primevue/button'
    import DateTable from 'primevue/datatable'
    import Column from 'primevue/column'



    export default {
        setup() {
            const breadcrumpsList = [
                {label: "Strona główna", routerName: 'mainPage', params: {}, query: {}},
                {label: "Ustawienia", routerName: 'dictionaryList', params: {}, query: {}},
                {label: "Słowniki"}
            ];
            return {
                breadcrumpsList
            }
        },


        components: {
            Breadcrumbs,
            'pv-progress-bar': ProgressBar,
            'pv-toolbar': Toolbar,
            'pv-button': Button,
            'pv-table': DateTable,
            'pv-column': Column,

        },

        computed: {
            ...mapState({
                dictionares: state => state.dictionary.dictionares
            }),
        },


        data() {
            return {
                loading: false,
                totalRecords: 0,
                enableAction: true,
                importing: false,
            }
        },


        methods: {

            create() {
                this.$router.replace({name: 'dictionaryAdd'});
            },

            edit(item) {
                this.$router.replace({name: 'dictionaryEdit', params: {id: item.id}});
            },

            values(item) {
                this.$router.replace({name: 'dictionaryValueList', params: {id: item.id}});
            },


            async refreshTable() {
                this.$store.dispatch('dictionary/findDictionares');
                this.loading = false;
            },




        },

        mounted() {
            this.loading = true;
            this.refreshTable();
        },

    }
</script>